import moment from 'moment-timezone';
import React, { useState } from 'react';

import { Container, InputContainer } from './DateForm.styled';
import { Answer } from 'kb-shared';
import { getNow, inPast } from 'kb-shared/utilities/momentHelpers';
import { FormText as Text } from 'screens/IntakeForm/components/Primitives/FormText';

import AnimatedWrapper from '../../AnimatedWrapper';
import FormButton from '../../FormButton';
import TextInput from '../../Primitives/TextInput';

export const DateForm = ({
  onContinue,
  onSave,
  answer,
  title,
  isRequired,
  skipLinkComponent,
  allowFutureDates = false
}: {
  onContinue?: () => void;
  onSave: (response: string) => void;
  answer: Answer | null;
  title: string;
  isRequired: boolean | null;
  skipLinkComponent: React.JSX.Element | null;
  allowFutureDates?: boolean;
}) => {
  const [date, setDate] = useState(answer?.data || '');

  const renderContinueButton = () => {
    if (!onContinue) return null;

    return (
      <AnimatedWrapper isHidden={!date}>
        <FormButton text={'Continue'} onClick={() => onContinue?.()} />
      </AnimatedWrapper>
    );
  };

  return (
    <Container>
      <Text isRequired={isRequired}>{title}</Text>
      <InputContainer>
        <TextInput
          value={date}
          placeholder={'(mm/dd/yyyy)'}
          type="date"
          max={allowFutureDates ? undefined : getNow('YYYY-MM-DD')}
          onChange={e => {
            const date = e.target.value;
            const safariFormatDate = moment(date, 'MM/DD/YYYY');
            const momentDate = safariFormatDate.isValid() ? safariFormatDate : moment(date);
            const dateIsAllowed = allowFutureDates
              ? momentDate.isValid()
              : momentDate.isValid() && inPast(momentDate);
            if (dateIsAllowed) {
              setDate(date);
            } else {
              setDate('');
            }
            onSave(date);
          }}
        />
      </InputContainer>
      {skipLinkComponent}
      {renderContinueButton()}
    </Container>
  );
};
